import type { IPlainObject } from "app/pages/sales-intelligence/types/plainObject";

import RangeSelectFilter from "../../components/filters/RangeSelectFilter/RangeSelectFilter";
import RangeSelectFilterResult from "../../components/filters/RangeSelectFilter/RangeSelectFilterResult";
import type { SearchFilterInstance } from "../../types/searchFilterInstance";
import FindRangeSelectFilter from "../RangeSelectFilter/RangeSelectFilter";

import type { IRangeSelectFilterOptions } from "./FilterOptions";

type Deps<T extends IPlainObject, A extends string = string> = Omit<
    SearchFilterInstance<T, A>,
    "title" | "tooltipText" | "filter" | "filterView" | "filterResultView"
> & {
    translationKey?: string;
    withTooltip?: boolean;

    rangeOptions: IRangeSelectFilterOptions;
};

const createRangeSelectFilter = <T extends IPlainObject, A extends string = string>({
    key,
    translationKey,
    withTooltip = true,
    rangeOptions,
    ...filterOptions
}: Deps<T, A>): SearchFilterInstance<T, A> => {
    const translation: string = translationKey ?? (key as string);

    return {
        key,
        title: { key: `si.lead_gen_filters.group.${translation}.name` },
        tooltipText: withTooltip ? { key: `si.lead_gen_filters.group.${translation}.tooltip` } : undefined,
        filter: new FindRangeSelectFilter({
            options: rangeOptions,
        }),
        filterView: RangeSelectFilter,
        filterResultView: RangeSelectFilterResult,

        ...filterOptions,
    } as unknown as SearchFilterInstance<T, A>;
};

export default createRangeSelectFilter;
